import store from '../../vuex'
import * as restfulService from './restfulService'

function _login (data) {
  return new Promise((resolve, reject) => {
    restfulService.post('auth', 'login', null, data)
      .then(loginResponse => {
        let person = loginResponse.user.pessoa
        loginResponse.user = {
          id: loginResponse.user.id,
          ref_pessoa: loginResponse.user.ref_pessoa,
          name: person.nome,
          cpf: person.cpf,
          rg_numero: person.rg_numero,
          birth_date: person.dt_nascimento,
          pessoa: person
        }
        store.dispatch('login', loginResponse).then(response => {
          resolve(response)
        })
      })
      .catch(e => {
        console.log(e)
        reject()
      })
  })
}

function _logout () {
  return new Promise((resolve, reject) => {
    let data = {}
    restfulService.post('auth', 'logout', null, data)
      .then(() => {
        store.dispatch('logout').then(() => {
          resolve()
        })
      })
      .catch(e => {
        console.log(e)
        reject()
      })
  })
}

export const login = _login
export const logout = _logout
